import { Stack } from '@mui/material';
import { isEmpty } from 'lodash';
import { useMemo } from 'react';
import { useQueryCompanySocialMedia } from 'src/services/queries';
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';

import LoadingSkeleton from 'src/components/common/LoadingSkeleton';
import SocialMedialTableComponent from 'src/features/CompanyDetail/SocialMedia/SocialMediaTable';

const SocialMediaTable = ({ id }: { id?: string | null }) => {
  const { data, isFetching } = useQueryCompanySocialMedia({
    id: id || '',
  });

  const socialMediasList = useMemo(() => {
    return getArrayDefault(data?.data?.social_medias).filter((item) => !isEmpty(item?.url));
  }, [data?.data?.social_medias]);

  const chatsList = useMemo(() => {
    return getArrayDefault(data?.data?.chats).filter((item) => !isEmpty(item?.url));
  }, [data?.data?.chats]);

  const directoriesList = useMemo(() => {
    return getArrayDefault(data?.data?.directories).filter((item) => !isEmpty(item?.url));
  }, [data?.data?.directories]);

  const ecommercesList = useMemo(() => {
    return getArrayDefault(data?.data?.ecommerces).filter((item) => !isEmpty(item?.url));
  }, [data?.data?.ecommerces]);

  if (isFetching) return <LoadingSkeleton height={40} count={10} />;

  if (isEmpty(socialMediasList) && isEmpty(chatsList) && isEmpty(directoriesList) && isEmpty(ecommercesList))
    return <SocialMedialTableComponent title="Social Media" data={[]} />;

  return (
    <Stack spacing={3}>
      {!isEmpty(socialMediasList) && <SocialMedialTableComponent data={socialMediasList} title="Social Media" />}
      {!isEmpty(chatsList) && <SocialMedialTableComponent data={chatsList} title="Chat" />}
      {!isEmpty(directoriesList) && <SocialMedialTableComponent data={directoriesList} title="Directory" />}
      {!isEmpty(ecommercesList) && <SocialMedialTableComponent data={ecommercesList} title="eCommerce" />}
    </Stack>
  );
};

export default SocialMediaTable;
